import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React from "react";
import { Link } from "react-router-dom";

const columns = [
  {
    field: "dist_name",
    headerName: "District",
    flex: 1,
    minWidth: 200,
    renderCell: (params) => (
      <Link
        className="text-[#8884d8] hover:underline"
        to={`/district/${params.row.dist_id}`}
      >
        {params.row.dist_name}
      </Link>
    ),
  },
  {
    field: "dist_id",
    headerName: "District ID",
    minWidth: 40,
    flex: 1,
  },
  {
    field: "center_count",
    headerName: "Center Count",
    minWidth: 40,
    flex: 1,
  },
  {
    field: "school_count",
    headerName: "School Count",
    minWidth: 40,
    flex: 1,
  },
  {
    field: "teacher_count",
    headerName: "Teacher Count",
    minWidth: 40,
    flex: 1,
  },
  {
    field: "video_usage_count",
    headerName: "Video Usage (mins)",
    minWidth: 40,
    flex: 1,
  },
  {
    field: "exercise_count",
    headerName: "Exercise Usage (mins)",
    minWidth: 40,
    flex: 1,
  },
  {
    field: "tot_usage",
    headerName: "Total Usage (mins)",
    minWidth: 40,
    flex: 1,
  },
];

function CustomToolbar() {
  return (
    <GridToolbarContainer
      sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
    >
      <GridToolbarQuickFilter />
      <div className="flex">
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
      </div>
    </GridToolbarContainer>
  );
}

export default function TableComponent({ data }) {
  const [pageSize, setPageSize] = React.useState(25);
  data = data.map((district) => ({
    ...district,
    dist_id: parseInt(district.dist_id),
    center_count: parseInt(district.center_count),
    exercise_count: parseInt(district.exercise_count),
    school_count: parseInt(district.school_count),
    teacher_count: parseInt(district.teacher_count),
    tot_usage: parseInt(district.tot_usage),
    video_usage_count: parseInt(district.video_usage_count),
  }));
  return (
    <DataGrid
      columns={columns}
      rows={data}
      pageSize={pageSize}
      rowsPerPageOptions={[25, 50, 100]}
      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
      pagination
      rowHeight={50}
      sx={{ marginTop: "2.5em" }}
      autoHeight={true}
      getRowId={(row) => row.dist_id}
      components={{
        Toolbar: CustomToolbar,
      }}
      componentsProps={{
        toolbar: {
          showQuickFilter: true,
          quickFilterProps: { debounceMs: 500 },
        },
      }}
    />
  );
}
